import React, { Component } from 'react'

export default class Status extends Component {
    getStatusColor(status) {
      const normalizedStatus = (status || "").toUpperCase();

      if (normalizedStatus === "AMBER" || normalizedStatus === "DEGRADED") {
        return "orange";
      }

      if (normalizedStatus === "FAIL" || normalizedStatus === "FAILING") {
        return "red";
      }

      return "inherit";
    }
    
    constructor(props) {
      super(props);
      this.state = {
        error: null,
        isLoaded: false,
        items: []
      };
    }
    componentDidMount() {
      fetch("https://status.api.aria.services/api/status")
        .then(res => res.json())
        .then(
          (result) => {
            // the API returns an array of service objects directly
            // each object already contains title, description, image, website, status
            this.setState({
              isLoaded: true,
              items: Array.isArray(result) ? result : []
            });
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            this.setState({
              isLoaded: true,
              error
            });
          }
        )
    }
  
    render() {
      const { error, isLoaded, items } = this.state;
      if (error) {
        return <div>Error: {error.message}</div>;
      } else if (!isLoaded) {
        return <div>Loading...</div>;
      } else if (!items || items.length === 0) {
        return <div>Error: no services returned from API.</div>
      } else {
        return (
            <div>
                <div className="timecode">Last checked @ <b><i>{new Date().toLocaleString() + ""}</i></b></div>
                <div className="container">
                {items.map(item => (
                    <div className="status-container">
                        <a href={item.website} className="hover"><div className="row logo">                        
                            <img width="100" height="100" src={item.image} alt={item.title} />
                        </div></a>
                        <div className="row">
                            <h2>{item.title}</h2>
                        </div>
                        {item.description && (
                          <div className="row">
                              <p>{item.description}</p>
                          </div>
                        )}
                        <div className="row" id={item.status.toLowerCase()}>
                          <h4 style={{ color: this.getStatusColor(item.status) }}>{item.status}</h4>
                        </div>             
                    </div>
                ))}
                </div>
            </div>
        );
      }
    }
  }
